import ViewListOutlinedIcon from '@material-ui/icons/ViewListOutlined';

import EstadoValidacionesList from './EstadoValidacionesList';
import EstadoValicionShow from './EstadoValicionShow';

const estadoValidaciones = {
    icon: ViewListOutlinedIcon,
    list: EstadoValidacionesList,
    show: EstadoValicionShow,
};

export default estadoValidaciones;
